<template>
	<div class="login-container">
		<div class="logo-info">
			<!-- <div>智慧空间资产运营系统</div> -->
			<img src="/img/login_logo_1.png" alt="logo" class="logo" />
		</div>
		<div class="login-card">
			<!-- <div class="login-title" v-if="logo">
				<img :src="logo" alt="logo" />
			</div> -->
			<div class="login-title">用户登录</div>
			<el-form :model="loginForm" :rules="rules" ref="loginForm" size="small">
				<el-form-item prop="username">
					<el-input size="small" v-model="loginForm.username" :placeholder="$t('login.usernamePlaceholder')">
						<template #prefix>
							<i class="el-icon-user" style="color: #000"></i>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item prop="passwd">
					<el-input
						size="small"
						v-model="loginForm.passwd"
						type="password"
						:placeholder="$t('login.passwordPlaceholder')">
						<template #prefix>
							<i class="el-icon-lock" style="color: #000"></i>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item prop="validateCode" class="captcha-item">
					<div class="captcha-container">
						<el-input
							size="small"
							v-model="loginForm.validateCode"
							:placeholder="$t('login.captchaPlaceholder')"></el-input>
						<img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" alt="验证码" />
					</div>
				</el-form-item>
				<div class="remember">
					<el-checkbox v-model="isRemember" size="small" />
					<div>记住密码</div>
				</div>
				<el-form-item>
					<el-button size="small" type="primary" @click="submitForm('loginForm')" :loading="loading">
						{{ $t('login.login') }}
					</el-button>
				</el-form-item>
			</el-form>
			<!-- Add a white line and copyright info below the form -->
			<!-- <div class="divider"></div> -->
			<!-- <div class="copyright">
				©2020-2026
				<span v-html="companyName"></span>
			</div> -->
		</div>
		<select-login-user ref="selectLoginUserRef" @select="handleSelect"></select-login-user>
	</div>
</template>

<script>
	// import { Search } from '@element-plus/icons-vue';
	import { login, getCaptcha, _loadStaffPrivileges } from '@/api/user/loginApi';
	import { _loadCommunityInfo } from '@/api/community/communityApi';
	import { listSystemInfo } from '@/api/system/systemInfoManageApi';
	import selectLoginUser from '@/components/user/selectLoginUser.vue';
	import { encrypt, decrypt } from '@/utils/crypto.js';

	export default {
		name: 'Login',
		data() {
			return {
				logo: '',
				isRemember: false,
				companyName: '',
				loginForm: {
					// username: 'wuxw',
					// passwd: 'admin',
					username: '',
					passwd: '',
					validateCode: '',
				},
				captchaUrl: '',
				loading: false,
				rules: {
					username: [{ required: true, message: this.$t('login.usernamePlaceholder'), trigger: 'blur' }],
					passwd: [{ required: true, message: this.$t('login.passwordPlaceholder'), trigger: 'blur' }],
					validateCode: [{ required: true, message: this.$t('login.captchaPlaceholder'), trigger: 'blur' }],
				},
			};
		},
		created() {
			this.clearLocalStorage();
			this.setRememberInfo();
			this.getSystemInfo();
			setTimeout(() => {
				this.refreshCaptcha();
			}, 1000);
		},
		components: {
			selectLoginUser,
		},
		methods: {
			async getSystemInfo() {
				const { data } = await listSystemInfo({ page: 1, row: 1 });
				this.logo = data[0].logoUrl;
				this.companyName = data[0].companyName;
			},
			clearLocalStorage() {
				const keepKeys = ['username', 'passwd', 'remember'];
				const remember = localStorage.getItem('remember');
				this.isRemember = remember === 'true';
				if (this.isRemember) {
					Object.keys(localStorage).forEach(key => {
						if (!keepKeys.includes(key)) {
							localStorage.removeItem(key);
						}
					});
				} else {
					localStorage.clear();
				}
			},
			setRememberInfo() {
				const remember = localStorage.getItem('remember');
				const username = localStorage.getItem('username');
				const passwd = localStorage.getItem('passwd');
				console.log(remember, username, passwd);
				if (this.isRemember) {
					this.isRemember = remember === 'true';
					this.loginForm.username = username;
					this.loginForm.passwd = decrypt(passwd);
				}
			},
			handerChange() {
				if (this.isRemember) {
					localStorage.setItem('remember', this.isRemember);
					localStorage.setItem('username', this.loginForm.username);
					localStorage.setItem('passwd', encrypt(this.loginForm.passwd));
				} else {
					localStorage.removeItem('username');
					localStorage.removeItem('passwd');
					localStorage.removeItem('remember', this.isRemember);
				}
			},
			async submitForm(formName) {
				this.$refs[formName].validate(async valid => {
					if (valid) {
						this.loading = true;
						try {
							const { data } = await login(this.loginForm).catch(error => {
								this.$message.error(error);
								this.refreshCaptcha();
								return { data: [] };
							});

							this.handerChange();

							if (!data || data.length == 0) {
								return;
							}

							if (data && data.length > 1) {
								this.$refs.selectLoginUserRef.openDialog(data);
								return;
							}
							this.handleSelect(data[0]);
						} catch (error) {
							console.error('登录失败：', error);
							this.refreshCaptcha();
						} finally {
							this.loading = false;
						}
					} else {
						return false;
					}
				});
			},
			async handleSelect(_userData) {
				localStorage.setItem('token', _userData.token);
				let _user = {
					userId: _userData.userId,
					name: _userData.name,
					tel: _userData.tel,
				};
				localStorage.setItem('user', JSON.stringify(_user));
				await _loadStaffPrivileges();
				await _loadCommunityInfo();
				this.$router.push('/');
			},
			async refreshCaptcha() {
				try {
					const res = await getCaptcha();
					console.log(res);
					this.captchaUrl = res;
				} catch (error) {
					console.error('获取验证码失败：', error);
					this.$message.error(this.$t('login.getCaptchaFailed'));
				}
			},
		},
	};
</script>

<style scoped>
	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background: url('/img/login-bg_x.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 0%;
		position: relative;
		overflow: hidden;
	}
	.logo {
		width: 296px;
		height: 51px;
	}
	.logo-info {
		position: absolute;
		left: 91px;
		top: 58px;
		font-size: 28px;
		line-height: 20px;
		margin-left: 16px;
		color: #1c1c1c;
		letter-spacing: 0.2rem;
	}

	.login-card {
		width: 323px;
		box-sizing: border-box;
		padding: 20px;
		background-color: rgba(255, 255, 255, 0.7);
		border-radius: 12px;
		position: absolute;
		right: 184px;
		top: 50%;
		transform: translateY(-50%);
		/* margin: -150px 0 0 0; */
		z-index: 99;
		text-align: center;
		padding: 26px 24px 23px 24px;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
	}

	.login-card .login-title {
		/* color: #fff;
		text-align: center;
		font-size: 48px; */
		font-weight: 600;
		font-size: 15px;
		color: #3e3e3e;
		text-align: left;
		padding-bottom: 14px;
		border-bottom: 1px solid #d5d5d5;
		margin-bottom: 23px;
	}

	.el-form-item {
		margin-bottom: 20px;
	}

	.el-input__inner {
		background: #fff;
		border: none;
		border-radius: 5px;
		color: #333;
		height: 40px;
	}

	.captcha-container {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.captcha-item .el-input {
		/* width: 70%;
		height: 38px;
		line-height: 1.3;
		border-width: 1px;
		border-style: solid;
		background-color: #fff;
		border-radius: 2px; */
	}

	.captcha-img {
		height: 30px;
		cursor: pointer;
		border-radius: 5px;
	}

	.remember {
		text-align: left;
		margin: 22px 0;
		font-size: 11px;
		color: #1d2129;
		line-height: 17px;
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.el-button--primary {
		width: 100%;
		background: #4080ff;
		border: none;
		font-size: 11px;
		color: #ffffff;
		line-height: 17px;
	}

	.el-button--primary:hover {
		opacity: 0.8;
		color: #fff;
	}

	/* Style for the white line */
	.divider {
		width: 100%;
		height: 1px;
		background-color: #fff;
		margin: 10px 0;
	}

	/* Style for the copyright text */
	.copyright {
		color: #fff;
		font-size: 14px;
		text-align: center;
		margin-top: 10px;
	}
</style>
